var root = require('./_root');

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;



//////////////////
// WEBPACK FOOTER
// ./node_modules/.4.17.10@lodash/_Uint8Array.js
// module id = 331
// module chunks = 1